import "./Navigator.less";

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { translate } from "react-i18next";
import capitalize from "capitalize";
import { CreateAccountContext } from "../../../contexts/contexts";

import BackIcon from "../../../assets/images/back_icon.svg";

class Navigator extends Component {
	static contextType = CreateAccountContext;

    render() {
		const summary = this.createParagraphOfParams();

        return (
            <div className="navigator" onClick={this.props.onBackClick}>
                <div className="navelement">
                    <img className="back-button" src={BackIcon} alt="" />
                    <p>{summary}</p>
                </div>
            </div>
        );
    }

    createParagraphOfParams() {
		const role = this.context.role;
		const school = this.context.school && this.context.school.name;
		const institution = this.context.institution && this.context.institution.name;
		const t = this.props.t;

        let params = [];

        if (role) params.push(role, school);
        if (institution) params.push(institution);
		
        params = params.map(capitalize);

        if (params[0] !== undefined) {
            params[0] = t(`role.${role}`);
        }
        if (params[1] !== undefined) {
            params[1] = t(`role.${school}`);
        }
        if (params[2] !== undefined) {
            params[2] = t(`institution.${institution}`);
        }
        
        return params.join(", ");
    }
}

const NavigatorWithRouter = withRouter(translate("registration")(Navigator));

export { NavigatorWithRouter as Navigator }


// WEBPACK FOOTER //
// ./src/components/CreateAccount/Navigator/Navigator.js